import Di from "common/resources/injectables/Di";
import { container } from "tsyringe";
import ContributorService from "services/projects/ContributorService";
import ProjectService from "services/ProjectService";
import ProjectTeamService from "services/projects/TeamService";
import UserService from "services/UserService";
import ChoiceService from "services/ChoiceService";

Di.setContributorService(container.resolve(ContributorService));
Di.setProjectService(container.resolve(ProjectService));
Di.setProjectTeamService(container.resolve(ProjectTeamService));
Di.setUserService(container.resolve(UserService));
Di.setChoiceService(container.resolve(ChoiceService));
